/* Svensk katalog for locale-completion-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('sv', {
  "common.rowUnavailable": "Data kunde inte laddas. F?rs?k igen.",
  "common.rowContextChanged": "Valt f?retag eller dokument har ?ndrats. ?ppna det igen.",
  "common.bankStatementIncomplete": "Kontoutdraget har inte laddats klart. F?rs?k igen.",
  "common.journalProofUnavailable": "Bokf?ringsunderlaget kunde inte verifieras.",

  'pay.employeesAwaitingPayment': '{{count}} anställda väntar på utbetalning',
  'pay.readyForPayment': 'Klar för utbetalning',
  'pay.readyForPaymentHelp': 'Godkända och bokförda lönekörningar som fortfarande har lön som inte är registrerad som utbetald.',
  'pay.noRunsAwaitingPayment': 'Inga lönekörningar väntar på utbetalning',
  'pay.noRunsAwaitingPaymentHint': 'Godkända lönekörningar visas här tills utbetalningen är registrerad.',
  'pay.draftPayrollRuns': 'Utkast',
  'pay.noDraftPayrollRuns': 'Inga löneutkast.',
  'buy.ownerOutlay': 'Utlägg från ägare',
  'home.followup.assetPostingTitle': 'Avskrivningar',
  'home.followup.assetPostingAction': 'Se avvikelse',
  'home.followup.assetPostingIssue': 'Automatisk avskrivning behöver uppföljning. Kontrollera tillgångens plan eller kontakta support. Plumme försöker igen när avvikelsen är åtgärdad.',
  'ui.cancel': 'Avbryt',
  'ui.close': 'Stäng',
  'ui.back': 'Tillbaka',
  'ui.continue': 'Fortsätt',
  'ui.open': 'Öppna',
  'app.close': 'Stäng',
  'common.loadMore': 'Ladda fler', 'common.loading': 'Laddar...',
  'shell.collapse': 'Fäll ihop menyn',
  'chat.cardFromFirm': 'Redovisningskonsulten skrev',
  'chat.cardFromYou': 'Du skrev',
  'chat.cardNone': 'Inga meddelanden ännu',
  'chat.firm': 'Din redovisningskonsult',
  'chat.helpTitle': 'Din redovisningskonsult',
  'chat.help': 'Skriv direkt till din redovisningskonsult. Bara du som ägare eller administratör ser den här konversationen.',
  'chat.cardOpenUnread': 'Läs meddelandet',
  'chat.cardOpen': 'Skicka ett meddelande',
  'chat.modalTitle': 'Du har ett oläst meddelande',
  'chat.modalOpen': 'Öppna chatt',
  'chat.modalBody': 'har skickat ett meddelande till dig som du inte har läst.',
  'chat.client': 'Klienten',
  'chat.subFirm': 'Dialog med klienten',
  'chat.subClient': 'Dialog med din redovisningskonsult',
  'chat.emptyFirm': 'Inga meddelanden ännu. Skriv till klienten här — de ser det i Plumme.',
  'chat.emptyClient': 'Inga meddelanden ännu. Fråga din redovisningskonsult om det du undrar över.',
  'chat.placeholder': 'Skriv ett meddelande …',
  'chat.send': 'Skicka',
  'rf.client.takeoverSaved': 'Övertagandedatumet är sparat',
  'rf.client.takeover': 'Övertagandedatum',
  'rf.client.takeoverHelp': 'Perioder och frister före detta datum räknas inte som byråns arbete. Klientens egen skyldighet ändras inte.',
  'rf.client.takeoverSave': 'Spara datum',
  'clo.cash.invalidAmount': 'Ange räknad kontantkassa.',
  'clo.cash.documentationRequired': 'Beskriv dokumentationen för inventeringen innan du godkänner.',
  'clo.cash.saved': 'Kassainventeringen är sparad.',
  'clo.cash.saveError': 'Kunde inte spara kassainventeringen.',
  'clo.cash.title': 'Mynt och sedlar',
  'clo.cash.readySubtitle': 'Kontantkassan är räknad och stämmer med konto 1900.',
  'clo.cash.naSubtitle': 'Ingen kontantkassa är registrerad på konto 1900.',
  'clo.cash.todoSubtitle': 'Räkna kontantkassan per 31.12 och jämför med konto 1900.',
  'clo.cash.noStatus': 'Kontantstatus har inte beräknats ännu.',
  'clo.cash.booked': 'Bokfört på 1900',
  'clo.cash.counted': 'Räknat per 31.12',
  'clo.cash.difference': 'Differens',
  'clo.cash.countedField': 'Räknad kontantkassa',
  'clo.cash.account': 'Kassakonto',
  'clo.cash.documentation': 'Dokumentation för inventeringen',
  'clo.cash.documentationPlaceholder': 'Till exempel: Kassan räknad 31.12 av verkställande direktör. Inventeringsblanketten är sparad i verifikationsmappen.',
  'clo.cash.noDifferenceHelp': 'När räknad kassa stämmer med konto 1900 sparas inventeringen som dokumentation utan extra kontering.',
  'clo.cash.surplusHelp': 'Differensen ökar konto 1900 och bokförs mot övrig intäkt.',
  'clo.cash.shortageHelp': 'Differensen minskar konto 1900 och bokförs mot övrig kostnad.',
  'clo.cash.approve': 'Godkänn inventering',
  'clo.chart.suggestionsReady': 'Förslagen är klara för godkännande.',
  'clo.chart.noSuggestions': 'Hittade inga säkra förslag.',
  'clo.chart.pickBeforeApprove': 'Välj standardkonto innan du godkänner.',
  'clo.chart.saved': '{{count}} kontokopplingar sparade',
  'clo.chart.saveError': 'Kunde inte spara kontokopplingarna.',
  'clo.chart.title': 'Kontoplan',
  'clo.chart.missingSubtitle': '{{count}} egna konton saknar koppling till standardkonto.',
  'clo.chart.readySubtitle': 'Kontoplanen är klar för bokslut.',
  'clo.chart.allMapped': 'Alla egendefinierade konton är kopplade till standardkonto.',
  'clo.chart.instructions': 'Välj vilket standardkonto varje eget konto motsvarar.',
  'clo.chart.aiSuggest': 'AI hittar förslag',
  'clo.chart.accountFallback': 'Konto {{code}}',
  'clo.chart.missingMapping': 'Saknar standardkoppling',
  'clo.chart.equivalent': 'Motsvarar standardkonto',
  'clo.chart.reset': 'Återställ förslag',
  'clo.chart.approve': 'Godkänn {{count}} förslag',
  'clo.share.title': 'Aktiekapital',
  'clo.share.readySubtitle': 'Aktiekapitalet är bokfört på konto 2000.',
  'clo.share.missingSubtitle': 'Kontrollera eller bokför aktiekapitalet innan bokslutet slutförs.',
  'clo.share.noStatus': 'Aktiekapitalstatus har inte beräknats ännu.',
  'clo.share.booked': 'Bokfört på 2000',
  'clo.share.minimum': 'Minimum för norskt AS',
  'clo.share.lossNote': 'Underskott eller förbrukat eget kapital ska normalt inte bokföras bort från konto 2000. Det bedöms inom eget kapital, resultatdisposition och fortsatt drift. Den här punkten kontrollerar bara att registrerat aktiekapital är bokfört som kredit på 2000.',
  'clo.share.freePosting': 'Bokför aktiekapital',
  'sharedText.app.employeePortalVerifyTitle': 'Bekräfta din e-postadress',
  'sharedText.auth.remember': 'Kom ihåg mig',
  'sharedText.auth.noAccount': 'Har du inget konto?',
  'sharedText.auth.forgotCopy': 'Ange e-postadressen du loggar in med, så skickar vi en länk för att skapa ett nytt lösenord.',
  'sharedText.acc.sentLinkTo': 'Vi har skickat en länk till',
  'sharedText.rep.export.year': 'År',
  'sharedText.bank.previewVoucher': 'Förhandsgranska verifikationen',
  'sharedText.km.returnTrip': 'Tur och retur',
  'sharedText.pay.paidOut': 'Utbetalt',
  'sharedText.inv.col.net': 'Netto',
  'sharedText.transaction.by': 'av',
  'sharedText.buy.pickCategory': 'Konto/kategori',
  'sharedText.vat.vat': 'Moms',
  'sharedText.sup.seeVoucher': 'Se verifikation',
  'sharedText.bwf.correctEntry': 'Korrigera kontering',
  'sharedText.ap.approve': 'Godkänn',
  'sharedText.sale.pay.partialStatusRemaining': 'återstår',
  'sharedText.helpTopics.ocrCorrection.title': 'Korrigera avläsning',
  'sharedText.pay.note': 'Anteckning',
  'sharedText.bank.openingBalance': 'Ingående saldo',
  'sharedText.asset.closing': 'Utgående saldo',
  'sharedText.sale.att.dropHere': 'Släpp verifikationen här',
  'sharedText.voucher.pickAccount': 'Välj konto',
  'sharedText.adv.scn.plan.interest': 'Ränta',
  'sharedText.sale.pay.fee': 'Avgift',
  'sharedText.ui.cancel': 'Avbryt',
  'sharedText.bwf.selectLine': 'Välj bankrad',
  'sharedText.bg.bankLines': 'Bankrader',
  'sharedText.home.ana.ring': 'Fördelning',
  'sharedText.pj.row.new': 'Ny rad',
  'sharedText.bank.bankLine': 'Bankrad',
  'sharedText.helpTopics.openItem.title': 'Öppen post',
  'sharedText.clo.amount': 'Belopp',
  'sharedText.adv.status.more': 'Fler val',
  'sharedText.inboxStatus.dropReceipts': 'Släpp verifikationerna här',
  'sharedText.bank.uploading': 'Laddar upp …',
  'sharedText.set.showAll': 'Visa alla',
  'sharedText.bank.voucherReceivedOn': 'Verifikation mottagen på',
  'sharedText.set.acc.lines': 'rader',
  'sharedText.nav.budget': 'Budget',
  'sharedText.bud.actual': 'Faktiskt',
  'sharedText.ui.close': 'Stäng',
  'sharedText.pay.signOut': 'Logga ut',
  'sharedText.rf.group.firm': 'Redovisningskonsult',
  'sharedText.rf.create.title': 'Skapa redovisningsbyrå',
  'sharedText.ui.open': 'Öppna',
  'sharedText.buy.next': 'Nästa',
  'sharedText.adv.docs.hide': 'Dölj',
  'sharedText.fe.decline': 'Avböj',
  'sharedText.common.yes': 'Ja',
  'sharedText.ap.review.checked': 'Kontrollerad',
  'sharedText.clo.pick': 'Välj',
  'sharedText.nav.taxReturn': 'Skattemelding',
  'sharedText.clo.financialYear': 'Räkenskapsåret',
  'sharedText.helpTopics.residualValue.title': 'Restvärde',
  'sharedText.clo.inventoryReview.undecided': 'Välj bedömning',
  'sharedText.helpTopics.readyForUse.title': 'Klar att användas',
  'sharedText.asset.work.residualValue': 'Förväntat restvärde',
  'sharedText.inv.credit.line': 'Rad',
  'sharedText.buy.paid': 'Betald',
  'sharedText.km.from': 'Från',
  'sharedText.km.to': 'Till',
  'sharedText.set.accountNo': 'Kontonr.',
  'sharedText.sale.credit.previewReason': 'Orsak:',
  'sharedText.clo.description': 'Beskrivning',
  'sharedText.prd.price': 'Pris',
  'sharedText.clo.sum': 'Summa',
  'sharedText.inv.kpi.sub.exVat': 'Exkl. moms',
  'sharedText.set.page': 'Sida',
  'sharedText.sale.cust.org': 'Org.nr',
  'sharedText.trv.vehicle': 'Fordon',
  'sharedText.ap.monthControl.finding.deviation': 'Möjlig avvikelse',
  'sharedText.vat.cancel': 'Avbryt',
  'sharedText.bank.review': 'Kontrollera',
  'sharedText.inbox.supplierInvoice': 'Leverantörsfaktura',
  'sharedText.bank.roundingHelp': 'Använd detta bara för en verklig liten avrundningsdifferens. Beloppet bokförs utan moms mot',
  'sharedText.trv.reason': 'Motivering',
  'sharedText.set.acc.vatRegisteredPick': 'Välj svar',
  'sharedText.set.acc.vatRegisteredUnknown': 'Vet inte',
  'sharedText.set.acc.vatRegisteredFrom': 'Momsregistrerad från',
  'sharedText.vat.due': 'Frist',
  'sharedText.pay.advance': 'Förskott',
  'sharedText.pay.aga': 'AGA',
  'sharedText.inv.col.number': 'Nr',
  'sharedText.onb.createPersonal': 'Skapa din privatekonomi',
  'sharedText.onb.createPersonalHelp': 'Detta skapar en separat privatekonomi-användare som du hittar via Min sida och användarväljaren.',
  'sharedText.onb.noBankData': 'Bankkopplingen är inte aktiv ännu. Du kan ladda upp kontoutdrag manuellt när du vill.',
  'sharedText.po.youHaveStated': 'Du har angett att',
  'sharedText.po.wealthStrongestOn': 'Din förmögenhet får högst poäng på',
  'sharedText.po.withYourAssumptions': 'Med de antaganden du har angett förändras din förmögenhet med ungefär',
  'sharedText.po.splitIsEven': 'Fördelningen är jämn. Ni delar',
  'sharedText.po.householdHasRegistered': 'Hushållet har registrerat',
  'sharedText.po.budgetTotal': 'Summa budget:',
  'sharedText.set.bank.typeTax': 'Skatteavdrag',
  'sharedText.clo.no': 'Nej',
  'sharedText.po.showingScenario': 'Visar scenario:',
  'sharedText.po.desiredNetWealth': 'Önskad nettoförmögenhet',
  'sharedText.po.lastsUntilYouAre': 'räcker tills du är',
  'sharedText.sd.transition.years': 'år',
  'sharedText.po.lasts': 'räcker',
  'sharedText.po.prioritise': 'Prioritera',
  'sharedText.adv.scn.loan.monthsUnit': 'mån',
  'sharedText.po.doYouWantToDelete': 'Vill du ta bort',
  'sharedText.po.householdSpends': 'Hushållet spenderar',
  'sharedText.po.iRecommend': 'Jag rekommenderar',
  'sharedText.po.debtFree': 'Skuldfri',
  'sharedText.po.interestPostedAs': 'Räntor och amorteringar på detta lån förs som',
  'sharedText.helpTopics.buffer.title': 'Likviditetsbuffert',
  'sharedText.clo.save': 'Spara',
  'sharedText.adv.profile.buffer': 'Önskad buffert',
  'sharedText.home.legend.income': 'Intäkt',
  'sharedText.set.bank.typeSavings': 'Sparande',
  'sharedText.pay.category': 'Kategori',
  'sharedText.set.account': 'Konto',
  'sharedText.po.allAccounts': 'Alla konton',
  'sharedText.adv.status.snooze7': 'Påminn mig om en vecka',
  'sharedText.po.yourHealthScoreIs': 'Din hälsopoäng är',
  'sharedText.po.outOf100': 'av 100',
  'sharedText.po.taxAssistant': 'Skattemeldingsassistent',
  'sharedText.cust.prev': 'Föregående',
  'sharedText.bank.finishReview': 'Slutför genomgång',
  'sharedText.po.checkBasis': 'Kontrollunderlag',
  'sharedText.clo.name': 'Namn',
  'sharedText.set.text': 'Text',
  'sharedText.sale.textLine.boldShort': 'F',
  'sharedText.sale.textLine.italicShort': 'K',
  'sharedText.sale.lines.useDivider': 'Använd avdelare',
  'sharedText.sale.textLine.dividerHint': 'Visa en linje under texten i dokumentet.',
  'sharedText.nav.products': 'Produkter',
  'sharedText.sale.textLine.titleNewText': 'Ny textrad',
  'sharedText.prd.deleted': 'Borttagen',
  'sharedText.pay.edit': 'Redigera',
  'sharedText.clo.delete': 'Ta bort',
  'sharedText.set.loans.startDate': 'Startdatum',
  'sharedText.helpTopics.unitCost.title': 'Inköpspris per enhet',
  'sharedText.pay.optional': 'Valfritt',
  'sharedText.registry.group': 'Produktgrupp',
  'sharedText.clo.add': 'Lägg till',
  'sharedText.ha.products.account': 'Intäktskonto',
  'sharedText.clo.accountNumber': 'Kontonummer',
  'sharedText.clo.accountName': 'Kontonamn',
  'sharedText.buy.supplierNew': 'Ny leverantör',
  'sharedText.auth.createAccount': 'Skapa konto',
  'sharedText.set.acc.equivalent': 'Motsvarar konto',
  'sharedText.bwf.entry': 'Kontering',
  'sharedText.sale.att.upload': 'Ladda upp bilaga',
  'sharedText.vat.settlement': 'Redovisning',
  'sharedText.ap.agent.invoice.selectRow': 'Välj faktura',
  'sharedText.ap.workspace.treatmentAsset': 'Registrera som inventarie',
  'sharedText.bank.receiptLinked': 'Kopplad till bankrad',
  'sharedText.sd.documents.count': 'dokument',
  'sharedText.set.debit': 'Debet',
  'sharedText.set.bank.accounts': 'Bankkonton',
  'sharedText.sd.deleteBusinessHelp': 'Ta bort företag tar bort det valda företaget efter 30 dagar via backend. Detta är en allvarlig åtgärd.',
  'sharedText.vat.rate': 'Sats',
  'sharedText.inv.bulk.noEmail': 'saknar e-post',
  'sharedText.trv.privateRefundOf': 'Privat återbetalning av',
  'sharedText.asset.group': 'Grupp',
  'sharedText.asset.opening': 'Ingående',
  'sharedText.asset.movements': 'Förändringar',
  'sharedText.set.credit': 'Kredit',
  'sharedText.voucher.backToVat': 'Tillbaka till MVA-meldingen',
  'sharedText.vat.vatCode': 'Momskod',
  'sharedText.bank.markVoucherLostTitle': 'Markera verifikation som förlorad',
  'sharedText.bank.voucherLostReason': 'Förklaring',
  'pay.salaryLineDeleted': 'Lönraden har tagits bort.',
  'pay.salaryLineNotFound': 'Lönraden finns inte längre.',
  'pay.deleteSalaryLine': 'Ta bort lönerad',
  'pay.deleteSalaryLineConfirm': 'Vill du ta bort ”{{name}}” från detta lönutkast?',
  'pay.accountingVouchers': 'Bokföringsverifikationer',
  'pay.payrollVoucher': 'Löneverifikation',
  'pay.paymentVoucher': 'Betalningsverifikation',
  'pay.paymentVoucherInDifferentYear': 'Betalningen är bokförd {{year}} och visas därför i råbalansen för det året.',
  'pay.settleSalaryLiability': 'Reglering av skuld för lön',
  'pay.settleEmployeeExpense': 'Reglering av utlägg',
  'pay.paymentFromBank': 'Utbetalning från bankkonto',
});
